import {EntityType, PropertyDefinition, PropertyDefinitionConfig} from '../types';

export const TEMPLATE_PROPERTY_DATE_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idPropertyDefinitionDateRepository',
	singular: 'Date Field',
};

export const TEMPLATE_PROPERTY_DATE_TEMPLATE_PROPERTIES: PropertyDefinition[] = [{
	id: 'idPropertyDefinitionDateTemplateTitleProperty',
	parentId: TEMPLATE_PROPERTY_DATE_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'label',
	label: 'Label',
	required: true,
	autoFocus: true,
}, {
	id: 'idPropertyDefinitionDateTemplateSlugProperty',
	parentId: TEMPLATE_PROPERTY_DATE_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'slug',
	label: 'Key',
	required: true,
	disabled: true,
}, {
	id: 'idPropertyDefinitionDateTemplateRequiredProperty',
	parentId: TEMPLATE_PROPERTY_DATE_REPOSITORY.id,
	type: EntityType.PropertyDefinitionBoolean,
	slug: 'required',
	label: 'Required',
	required: true,
	defaultChecked: true,
}];
